/* takes in network response user/read list and currently selected users and merges both. Removes duplicate ID */
export const generateCandidateSelectionListOnUserRead = (selection, apiResults) => {
  const unselectedCandidates = apiResults.filter((cv) => !selection.find((e) => e._id === cv._id));

  return unselectedCandidates;
};

export default generateCandidateSelectionListOnUserRead;
